import { render, staticRenderFns } from "./Gallery5.vue?vue&type=template&id=eff7ad4a&"
import script from "./Gallery5.vue?vue&type=script&lang=js&"
export * from "./Gallery5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports